import React from 'react';
import './AboutUs.css';

const AboutUs = () => {
  return (
    <div className="about-container">
      <div className="about-content">
        <h1>About Us</h1>
        <div className="brand-intro">
          <p><strong>Hello Traders is a part of Manki Enterprise.</strong></p>
        </div>
        
        <p className="intro">
          Welcome to your go-to destination for fashion that inspires confidence and celebrates individuality.
        </p>
        <p>
          At our fashion store, we believe that what you wear should reflect who you are. That's why we offer a thoughtfully curated collection of modern, ethnic, western, and fusion wear designed to elevate your wardrobe and your confidence.
        </p>

        <h2>What We Offer</h2>
        <div className="offerings">
          <div className="offering-item">
            <h3>Men's Fashion</h3>
            <p>From casual staples to sharp formalwear, our men's collection balances style with comfort—perfect for every occasion.</p>
          </div>
          <div className="offering-item">
            <h3>Women's Fashion</h3>
            <p>Whether it's everyday essentials, elegant ethnic wear, or the latest in contemporary fashion, our women's styles are made to empower.</p>
          </div>
          <div className="offering-item">
            <h3>Kids' Wear</h3>
            <p>Comfortable, playful, and trend-aligned clothing for the little ones, so they can shine in their own way.</p>
          </div>
          <div className="offering-item">
            <h3>Accessories & More</h3>
            <p>Complete your look with handpicked accessories that blend fashion with function.</p>
          </div>
        </div>

        <h2>Our Style Philosophy</h2>
        <p>
          We blend timeless trends with the latest in design innovation, offering styles that are versatile, wearable, and affordable. Whether you're dressing for a festival, a meeting, or a weekend out, you'll find pieces that work with your lifestyle and mood.
        </p>

        <h2>Why Shop With Us?</h2>
        <ul className="features-list">
          <li><strong>Curated Collection:</strong> Hand-selected styles that are trendy, comfortable, and inclusive.</li>
          <li><strong>Quality Focused:</strong> We prioritize quality fabrics and fine craftsmanship.</li>
          <li><strong>Customer-Centric:</strong> From easy returns to friendly service, we make shopping simple and enjoyable.</li>
          <li><strong>New Arrivals Weekly:</strong> Stay ahead of trends with our ever-evolving collections.</li>
        </ul>

        <h2>Our Vision</h2>
        <p className="vision">
          To create a space where fashion meets everyday life—where you can find what fits your body, suits your taste, and speaks to your spirit.
        </p>
        
        <div className="contact-info">
          <h2>Contact Us</h2>
          <p>For any inquiries, please reach out to us:</p>
          <ul>
            <li>Email: info@mankienterprises.com</li>
            <li>Phone: +91 98765 43210</li>
            <li>Address: 123 Fashion Street, New Delhi, India</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AboutUs; 